module.exports = __webpack_public_path__ + "img/accounts.837b4b05.png";